// extracted by mini-css-extract-plugin
export default {"container":"Natures_container__fcoro","table":"Natures_table__og0re","nature":"Natures_nature__Cewje","increased":"Natures_increased__HMQM3","decreased":"Natures_decreased__O7VxG"};